import { createPortal } from "react-dom";
import { fileUrl } from "@/lib/api";
import { User } from "lucide-react";

export function Portal({ children }) {
  if (typeof document === "undefined") return null;
  return createPortal(children, document.body);
}

export function Brand({ size = 32, withText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <img
        src="/brand/icon-512.png"
        alt="InfoKeepSake"
        width={size}
        height={size}
        className="rounded-[22%] object-cover shadow-lg shadow-blue-900/40"
        style={{ width: size, height: size }}
      />
      {withText && (
        <span className="font-display font-extrabold tracking-tight text-slate-50 text-lg">
          Info<span className="text-sky-400">KeepSake</span>
        </span>
      )}
    </div>
  );
}

export function Avatar({ photo, name = "", size = 44, ring = true }) {
  const initials = (name || "?")
    .split(" ")
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  const ringCls = ring ? "border-2 border-sky-400/40 ring-2 ring-blue-600/20" : "";
  if (photo) {
    return (
      <img
        src={fileUrl(photo)}
        alt={name}
        className={`rounded-full object-cover ${ringCls}`}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <div
      className={`rounded-full flex items-center justify-center bg-gradient-to-br from-blue-600/30 to-sky-500/20 text-sky-200 font-semibold ${ringCls}`}
      style={{ width: size, height: size, fontSize: size * 0.36 }}
    >
      {initials || <User size={size * 0.5} />}
    </div>
  );
}

export function Loader({ label = "Loading…" }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-slate-500">
      <div className="w-8 h-8 rounded-full border-2 border-sky-500/30 border-t-sky-400 animate-spin" />
      <p className="mt-3 text-sm">{label}</p>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle, action, testId }) {
  return (
    <div className="iks-card p-8 text-center flex flex-col items-center iks-fade-up" data-testid={testId}>
      {Icon && (
        <div className="w-14 h-14 rounded-2xl bg-sky-500/10 flex items-center justify-center mb-4">
          <Icon className="text-sky-400" size={26} />
        </div>
      )}
      <h3 className="font-display font-semibold text-slate-100 text-lg">{title}</h3>
      {subtitle && <p className="text-slate-400 text-sm mt-1.5 max-w-xs">{subtitle}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function SectionLabel({ children }) {
  return (
    <p className="text-xs font-semibold tracking-wider uppercase text-sky-400 mb-2">{children}</p>
  );
}
